
<template>
  <div class="example-3d" style="margin-top:10em;">
    <swiper class="swiper" :options="swiperOption">
      <swiper-slide>
        <div class="swip">
          <center>
            <CButton block color="warning"
            
            >Select</CButton>
            <div class="name">
              <h1>Lesson Name</h1>
            </div>
          </center>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="swip2">
          <center>
            <CButton block color="warning">Select</CButton>
            <div class="name">
              <h1>Lesson Name</h1>
            </div>
          </center>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="swip3">
          <center>
            <CButton block color="warning">Select</CButton>
            <div class="name">
              <h1>Lesson Name</h1>
            </div>
          </center>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="swip4">
          <center>
            <CButton block color="warning">Select</CButton>
            <div class="name">
              <h1>Lesson Name</h1>
            </div>
          </center>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="swip5">
          <center>
            <CButton block color="warning">Select</CButton>
            <div class="name">
              <h1>Lesson Name</h1>
            </div>
          </center>
        </div>
      </swiper-slide>
      <swiper-slide>
         <div class="swip6">
          <center>
            <CButton block color="warning">Select</CButton>
            <div class="name">
              <h1>Lesson Name</h1>
            </div>
          </center>
        </div>
      </swiper-slide>
      <swiper-slide>
         <div class="swip7">
          <center>
            <CButton block color="warning">Select</CButton>
            <div class="name">
              <h1>Lesson Name</h1>
            </div>
          </center>
        </div>
      </swiper-slide>

      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  name: "swiper-example-3d-coverflow-loop-group",
  title: "3D Coverflow effect Loop mode with multiple slides per group",
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      swiperOption: {
        effect: "coverflow",
        slidesPerView: 3,
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        loop: true,
        loopFillGroupWithBlank: true,
        coverflowEffect: {
          rotate: 0,
          stretch: 5,
          depth: 25,
          modifier: 5,
          slideShadows: true
        },
        autoplay: {
        delay: 2800,
        disableOnInteraction: false,
      },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
      }      
      }
    };
  }
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap");
.example-3d {
  width: 100%;
  height: 600px;
  padding-top: 50px;
  padding-bottom: 50px;
}

.swiper {
  height: 100%;
  width: 100%;

  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 900px;
    height: 400px;
    text-align: center;
    font-weight: bold;
    background-color: transparent;
    background-position: center;
    background-size: cover;
    color: white;
  }
  .swip {
    width: 100%;
    height: -webkit-fill-available;
    background-repeat: no-repeat;
    background-size: 100%;
    background-image: url("https://kpopping.com/uploads/documents/IMG_20190726_002702(4).jpeg");
  }
  .swip2 {
    width: 100%;
    height: -webkit-fill-available;
    background-repeat: no-repeat;
    background-size: 100%;
    background-image: url("https://kpopping.com/uploads/documents/IMG_20190726_003408.jpeg");
  }
  .swip3 {
    width: 100%;
    height: -webkit-fill-available;
    background-repeat: no-repeat;
    background-size: 100%;
    background-image: url("https://f.ptcdn.info/513/061/000/pjymxni7gdPPt35G40q-o.jpg");
  }
  .swip4 {
    width: 100%;
    height: -webkit-fill-available;
    background-repeat: no-repeat;
    background-size: 100%;
    background-image: url("https://pbs.twimg.com/media/DYdOEjWVAAACspT.jpg");
  }
  .swip5 {
    width: 100%;
    height: -webkit-fill-available;
    background-repeat: no-repeat;
    background-size: 100%;
    background-image: url("https://pbs.twimg.com/media/D1I5W4rVAAABuce.png:large");
  }
  .swip6 {
    width: 100%;
    height: -webkit-fill-available;
    background-repeat: no-repeat;
    background-size: 100%;
    background-image: url("https://i.ytimg.com/vi/KhrtA9tIQIU/maxresdefault.jpg");
  }
  .swip7 {
    width: 100%;
    height: -webkit-fill-available;
    background-repeat: no-repeat;
    background-size: 100%;
    background-image: url("https://pm1.narvii.com/7539/a10f7ef394d9b7ac2e53fc02820098c0b6bdab5br1-1910-1079v2_uhq.jpg");
  }
  .btn {
    width: 150px;
    height: 50px;
    border-radius: 25px;
    margin-top: 20rem;
  }
  .name h1 {
    font-size: 20px;
    color: black;
    margin-top: 2.5rem;
    font-size: 40px;
    font-family: "Roboto", sans-serif;
    font-weight: 300;
  }

  .swiper-pagination {
    ::v-deep .swiper-pagination-bullet.swiper-pagination-bullet-active {
      background-color: white;
    }
  
  }
}
</style>